// window event → open the 快捷键和写法 sheet (input-center PRD §27). Its own
// module so a sender (the account menu in Header) does not pull in the input
// center's chunk; the sheet itself lives in InputCenter, mounted on every
// signed-in page.
export const SHORTCUTS_EVENT = 'asaptodo:shortcuts-open';

export function openShortcuts() {
  window.dispatchEvent(new CustomEvent(SHORTCUTS_EVENT));
}
